// extracted by mini-css-extract-plugin
module.exports = {"headerContainerRow":"PageHeading-module--headerContainerRow--35uFA"};